import { z } from 'zod';
export const platformSubscriptionStates = ['pilot', 'active', 'past_due', 'cancelled'];
export const platformSubscriptionTermsSchema = z.strictObject({
    status: z.enum(platformSubscriptionStates),
    amountCents: z.number().int().min(0).max(100_000_000),
    currency: z.string().regex(/^[A-Z]{3}$/),
    billingInterval: z.enum(['month', 'year']),
    currentTermStart: z.iso.datetime(),
    currentTermEnd: z.iso.datetime(),
    cancelAtPeriodEnd: z.boolean(),
    reason: z.string().trim().min(3).max(500),
}).superRefine((value, ctx) => {
    if (Date.parse(value.currentTermEnd) <= Date.parse(value.currentTermStart))
        ctx.addIssue({ code: 'custom', path: ['currentTermEnd'], message: 'The term must end after it starts.' });
    if (value.status === 'pilot' && value.amountCents !== 0)
        ctx.addIssue({ code: 'custom', path: ['amountCents'], message: 'A pilot has no subscription fee.' });
    if (['active', 'past_due'].includes(value.status) && value.amountCents <= 0)
        ctx.addIssue({ code: 'custom', path: ['amountCents'], message: 'Paid terms require an agreed amount.' });
    if (value.status === 'cancelled' && value.cancelAtPeriodEnd)
        ctx.addIssue({ code: 'custom', path: ['cancelAtPeriodEnd'], message: 'An immediate cancellation cannot also be scheduled.' });
});
export const platformRefundFollowUpStates = ['open', 'in_progress', 'complete'];
//# sourceMappingURL=platform-billing.js.map